export default "__VITE_ASSET__NtU80bWM__"